export const SHOW_ARROW_BOTTOM = 10
export const HIDE_AVATARS_WIDTH = 404
export const SENDING_MESSAGES_KEY = 'sendingMessages'
export const ESTIMATE_SIZE = 66
export const OVERSCAN = 12
export const SCROLL_END_THRESHOLD = 80
export const START_REACHED_THRESHOLD = 6
export const PADDING_END = 24
